/** @jsxImportSource @emotion/react */
import { useState } from "react";
import { FacebookProvider, Initialize, Login } from "react-facebook";
import "twin.macro";
import tw from "twin.macro";
import { useAuthenticateWithFacebookMutation } from "../authentication/AuthenticationAPI";
import i18n from "../i18n";
import { ButtonBase } from "./Button";
import { ErrorAlert } from "./ErrorAlert";

const FacebookLoginButton = ({ variant = "default", isReady, children, disabled, ...props }) => {
  const [facebookError, setFacebookError] = useState(null);
  const {
    mutateAsync: authenticateWithFacebook,
    status,
    error,
  } = useAuthenticateWithFacebookMutation();
  const onCompleted = async (result) => {
    try {
      await authenticateWithFacebook(result);
    } catch (e) {}
  };
  const onError = (error) => {
    setFacebookError(error);
  };
  return (
    <>
      <ErrorAlert error={error || facebookError} />
      <Login scope="email" onCompleted={onCompleted} onError={onError}>
        {({ loading, handleClick }) => (
          <ButtonBase
            css={[
              variant === "default" &&
                tw`border-gray-300 shadow-sm text-gray-700 bg-white hover:(bg-gray-50) focus:(outline-none ring ring-gray-200)`,
              variant === "primary" &&
                tw`border-transparent shadow-sm text-white background-color[#1877f2] focus:(outline-none ring ring-blue-200)`,
            ]}
            onClick={handleClick}
            disabled={!isReady || loading || status === "loading" || disabled}
            {...props}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              aria-hidden="true"
              display="block"
              viewBox="0 0 24 24"
            >
              <defs>
                <path id="a" d="M0 0h24v24H0z" />
              </defs>
              <g fill="none" fillRule="evenodd">
                <mask id="b" fill="#fff">
                  <use xlinkHref="#a" />
                </mask>
                <path
                  fill={variant === "default" ? "#1877f2" : "#fff"}
                  d="M24 12a12 12 0 10-14 12v-9H7v-3h3V9c0-3 2-4 5-4h2v3h-1c-2 0-2 1-2 2v2h3v3h-3v9c6-1 10-6 10-12"
                  mask="url(#b)"
                />
                <path
                  fill={variant === "default" ? "#fff" : "#1877f2"}
                  d="M17 15v-3h-3v-2c0-1 0-2 2-2h1V5h-2c-3 0-5 1-5 4v3H7v3h3v9a12 12 0 004 0v-9h3"
                />
              </g>
            </svg>
            <span
              tw="mr-3 flex-1 whitespace-nowrap"
              css={{
                letterSpacing: ".25px",
              }}
            >
              {children}
            </span>
          </ButtonBase>
        )}
      </Login>
    </>
  );
};

export const FacebookLogin = (props) => {
  return (
    <FacebookProvider
      version="v9.0"
      language={i18n.language}
      appId={process.env.REACT_APP_FACEBOOK_APP_ID}
    >
      <Initialize>
        {(facebookProps) => <FacebookLoginButton {...props} {...facebookProps} />}
      </Initialize>
    </FacebookProvider>
  );
};
